export const apiRoutes = {
  api_r_user_module_lawFinder_getPermissions: {
    path: 'm/law-finder/get-permissions/',
  },
  api_r_user_module_lawFinder_getModuleData: {
    path: 'm/law-finder/get-module-data/',
  },
  api_r_user_module_lawFinder_getLaws: {
    path: 'm/law-finder/get-laws/',
  },
  api_r_user_module_lawFinder_getLawsDetails: {
    path: 'm/law-finder/get-laws-details/',
  },
  api_r_user_module_lawFinder_changeLawState: {
    path: 'm/law-finder/change-law-state/',
  },
  api_r_user_module_lawFinder_addLawEvidence: {
    path: 'm/law-finder/add-law-evidence/',
  },
  api_r_user_module_lawFinder_removeLawEvidence: {
    path: 'm/law-finder/remove-law-evidence/',
  },
  api_r_user_module_lawFinder_getArticleData: {
    path: 'm/law-finder/get-article-data/',
  },
  api_r_user_module_lawFinder_checkArticle: {
    path: 'm/law-finder/check-article/',
  },
  api_r_user_module_lawFinder_getLawEncryptedFilters: {
    path: 'm/law-finder/get-law-encrypted-filters/',
  },
  api_r_user_module_lawFinder_exportReport: {
    path: 'm/law-finder/export-report/',
  },
  api_r_user_module_lawFinder_exportLaw: {
    path: 'm/law-finder/export-law/',
  },
  api_r_user_module_lawFinder_lawFile_download: {
    path: 'm/law-finder/law-file/download/',
  },
  api_r_user_module_lawFinder_lawEvidence_download: {
    path: 'm/law-finder/law-evidence/download/',
  },
};
